


































import { Component, Prop, Vue } from 'vue-property-decorator';

type Password = {
  value: string;
  hide: boolean;
};

@Component
export default class AuthFieldPassword extends Vue {
  @Prop({ required: true }) private password!: Password['value'];
  @Prop(Boolean) protected disabled!: boolean;

  hide: Password['hide'] = true;

  get value(): Password['value'] {
    return this.password;
  }

  set value(value: Password['value']) {
    this.$emit('update:password', value);
  }

  get passwordRequirements() {
    const items = {
      length: {
        label: String(this.$t('commons.sentences.at-least-characters--s', { value: 8 })),
        valide: false,
      },
      number: {
        label: String(this.$t('commons.sentences.must-contain-number--s')),
        valide: false,
      },
      uppercase: {
        label: String(this.$t('commons.sentences.must-contain-uppercase--s')),
        valide: false,
      },
      special: {
        label: String(this.$t('commons.sentences.must-contain-special--s')),
        valide: false,
      },
      lowercase: {
        label: String(this.$t('commons.sentences.must-contain-lowercase--s')),
        valide: false,
      },
    };

    const p = this.value || '';
    let value = 0;
    let color;

    // Lowercase letter
    if (/[a-z]/gm.test(p)) {
      value += 10;
      items.lowercase.valide = true;
    }
    // Uppercase letter
    if (/[A-Z]/gm.test(p)) {
      value += 10;
      items.uppercase.valide = true;
    }
    // Number
    if (/[0-9]/gm.test(p)) {
      value += 10;
      items.number.valide = true;
    }
    // Special character
    if (/[^A-Za-z0-9\s]/gm.test(p)) {
      value += 10;
      items.special.valide = true;
    }

    value += p.length < 8 ? p.length * 7.5 : 60;
    if (p.length >= 8) {
      items.length.valide = true;
    }

    switch (true) {
      case value >= 100:
        color = 'success';
        break;
      case value >= 60:
        color = 'warning';
        break;
      default:
        color = 'error';
        break;
    }

    return {
      items,
      value,
      color,
    };
  }
}
